import { render, staticRenderFns } from "./PromoCodeApplyOnWebsite.vue?vue&type=template&id=2e0dc6c0&scoped=true&"
import script from "./PromoCodeApplyOnWebsite.vue?vue&type=script&lang=js&"
export * from "./PromoCodeApplyOnWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0dc6c0",
  null
  
)

export default component.exports